<template>
    <div class="box">
        <div class="filex">
            <div class="langs">
                <div @click="changeLangs('zh')" class="more2">中文版 </div>
                <span>|</span>
                <div @click="changeLangs('en')" class="more2">English</div>
            </div>
            <div class="left">
                <img src="@/assets/image/enLogo.png" />
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'NavBar',
    props: {
        num: Number
    },
    data() {
        return {
            showTab: false,
            Index: 0,

        }
    },

    methods: {
        changeTab(e) {
            this.Index = e
        },
        leave() {
            // this.showTab = false
            this.Index = 0
        },
        changeLangs(value) {
            console.log("value", value)
            if (value === 'zh') {
                this.$i18n.locale = 'zh'
                // localStorage.setItem('lang', 'en') // en表示英文，zh表示中文，可根据自己喜好设定，尽量通俗易懂
                this.$nextTick(() => {
                    this.$router.push({
                        name: 'Home'
                    })
                })
            } else {
                location.reload()
                this.$i18n.locale = 'en'
                // localStorage.setItem('lang', 'zh')
            }
            location.replace(location) //刷新网页

        }
    }
}
</script>

<style scoped lang="scss">
.box {
    width: 100%;
    height: 100px;
    background: url('../assets/image/repeat.png');
    background-repeat: repeat;
    position: fixed;
    top: 0;
    left: 0;

    .filex {
        width: 1000px;
        height: 100px;
        margin: 0 auto;
        position: relative;

    }

    .langs {
        display: flex;
        align-items: center;
        position: absolute;
        top: 7px;
        right: 0px;
        z-index: 999;

        span {
            margin: 0px 3px;
            line-height: 25px;
            font-size: 12px;
            // font-family: 微软雅黑;
            color: rgb(102, 102, 102);
            cursor: pointer;
        }
    }

    .left {
        width: 750px;
        height: 100px;
        float: left;
    }

    .more2 {
        line-height: 25px;
		font-size: 12px;
		color: rgb(102, 102, 102);
		cursor: pointer;
    }

    .more2:hover {
        color: #E32C1A
    }

}
</style>
